import { Route } from 'react-router-dom';

import BulkMoveAssignSlots from './manage-spot/bulk-move-transactions/bulk-move-assign-slots.component';
import BulkMoveConfirm from './manage-spot/bulk-move-transactions/bulk-move-confirm.component';
import BulkMoveSelectSpot from './manage-spot/bulk-move-transactions/bulk-move-select-spot.component';
import BulkMoveTransactionsList from './manage-spot/bulk-move-transactions/bulk-move-transactions-list.component';
import BulkRemoveConfirm from './manage-spot/bulk-move-transactions/bulk-remove-confirm.component';
import { LendingStockDetail } from './manage-spot/lending-stock/lending-stock-detail/lending-stock-detail.component';
import LendingStockList from './manage-spot/lending-stock/lending-stock.component';
import ManageOverview from './manage-spot/manage-overview/manage-overview.component';
import MoveConfirm from './manage-spot/move-transaction/move-confirm.component';
import MoveSelectSlot from './manage-spot/move-transaction/move-select-slot.component';
import MoveSelectSpot from './manage-spot/move-transaction/move-select-spot.component';
import OpenSlots from './manage-spot/open-slots/open-slots.component';
import PuDoAwaitingDropOff from './manage-spot/pudo-awaiting-drop-off/pudo-awaiting-drop-off.component';
import PuDoAwaitingPickUp from './manage-spot/pudo-awaiting-pick-up/pudo-awaiting-pick-up.component';
import PudoTransactionDetail from './manage-spot/pudo-transactions-detail/pudo-transactions-detail.component';
import { EquipmentList } from './manage-spot/slot-detail/equipment-list/equipment-list.component';
import { ProductList } from './manage-spot/slot-detail/product-list/product-list.component';
import SlotDetail from './manage-spot/slot-detail/slot-detail.component';
import { VendingStockDetail } from './manage-spot/vending-stock/vending-stock-detail/vending-stock-detail.component';
import VendingStockList from './manage-spot/vending-stock/vending-stock.component';
import ViewContent from './manage-spot/view-content/view-content.component';

export function KioskRoutes() {
    return (
        <Route path='spots/layout'>
            <Route
                index
                element={<ManageOverview />}
            />
            <Route path='pudo'>
                <Route
                    path='awaiting-drop-off'
                    element={<PuDoAwaitingDropOff />}
                />
                <Route
                    path='awaiting-pick-up'
                    element={<PuDoAwaitingPickUp />}
                />
                <Route
                    path='transactions/:id'
                    element={<PudoTransactionDetail />}
                />
                <Route path='bulk-move-transactions'>
                    <Route
                        index
                        element={<BulkMoveTransactionsList />}
                    />
                    <Route
                        path='move'
                        element={<BulkMoveSelectSpot />}
                    />
                    <Route
                        path='move/spot/:destSpotId'
                        element={<BulkMoveAssignSlots />}
                    />
                    <Route
                        path='move/spot/:destSpotId/confirm'
                        element={<BulkMoveConfirm />}
                    />
                    <Route
                        path='remove'
                        element={<BulkRemoveConfirm />}
                    />
                </Route>
            </Route>

            <Route path='vending-stock'>
                <Route
                    index
                    element={<VendingStockList />}
                />
                <Route
                    path=':productId'
                    element={<VendingStockDetail />}
                />
            </Route>
            <Route path='lending-stock'>
                <Route
                    index
                    element={<LendingStockList />}
                />
                <Route
                    path=':productId'
                    element={<LendingStockDetail />}
                />
            </Route>
            <Route
                path='open-slots'
                element={<OpenSlots />}
            />
            <Route
                path='view-content'
                element={<ViewContent />}
            />
            <Route path='slot'>
                <Route path=':slotId'>
                    <Route
                        index
                        element={<SlotDetail />}
                    />
                    <Route path='move/:transactionId'>
                        <Route
                            index
                            element={<MoveSelectSpot />}
                        />
                        <Route path='spot/:destSpotId'>
                            <Route
                                index
                                element={<MoveSelectSlot />}
                            />
                            <Route
                                path='slot/:destSlotId/confirm'
                                element={<MoveConfirm />}
                            />
                        </Route>
                    </Route>
                    <Route path='add-product'>
                        <Route
                            index
                            element={<ProductList />}
                        />
                        <Route
                            path=':productId/add-equipment'
                            element={<EquipmentList />}
                        />
                    </Route>
                </Route>
            </Route>
        </Route>
    );
}
